import { KeyframeConfig } from "../../../models/animations.model";
import { ObjectMeasures } from "../../../models/canvas.model";

const TUMBLE_ANGLE = 30;

export const getTumbleInBaseKeyframe = (
  objectMeasures: ObjectMeasures,
  canvasMeasures: ObjectMeasures,
  angle: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        keyframes: [
          {
            left: canvasMeasures.left - objectMeasures.width,
            top: objectMeasures.top + objectMeasures.height / 4,
            angle: angle - TUMBLE_ANGLE,
          },
          {
            left: objectMeasures.left,
            top: objectMeasures.top,
            angle: angle,
          },
        ],
      },
    },
  ];
};

export const getTumbleOutBaseKeyframe = (
  objectMeasures: ObjectMeasures,
  canvasMeasures: ObjectMeasures,
  angle: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        keyframes: [
          {
            left: objectMeasures.left,
            top: objectMeasures.top,
            angle: angle,
          },
          {
            left:
              canvasMeasures.left +
              canvasMeasures.width +
              objectMeasures.width / 2,
            top: objectMeasures.top - objectMeasures.height / 2,
            angle: angle + TUMBLE_ANGLE,
          },
        ],
      },
    },
  ];
};
